// extracted by mini-css-extract-plugin
export default {"content":"AL-z","lookName":"BL-z","shopTheLookContainer":"CL-z","productContainer":"DL-z","imageContainer":"EL-z","mainImage":"FL-z"};